export function headerSize() {
    const header = document.querySelector('.header--js');
    setSize();
    new ResizeObserver(setSize).observe(header);

    function setSize() {
        const height = Math.ceil(header.getBoundingClientRect().height);
        document.body.style.setProperty('--header-height', `${height}px`);
    }

    const sideColumns = header.querySelectorAll('.header-side-column-content--js');
    if (sideColumns.length > 1) {
        setSideColSize();
        sideColumns.forEach((col) => {
            new ResizeObserver(setSideColSize).observe(col);
        });
    }
    function setSideColSize() {
        let width = 0;
        sideColumns.forEach((col) => {
            if (col.scrollWidth > width) width = col.scrollWidth;
        });
        header.style.setProperty('--side-columns-max-content-width', `${width}px`);
    }
}
